<template>
  <v-container fluid>
    <intro-text/>
    <v-carousel
      v-model="carousel"
      class="carousel"
      hide-delimiters
      height="100%"
      :show-arrows="false"
    >
      <button v-show="carousel > 0" class="prev" @click="carousel--">
        <v-hover
          v-slot:default="{ hover }"
        >
          <img :src="hover ? require('~/assets/img/icon-btn-hover.svg') : require('~/assets/img/icon-btn.svg')" alt="Vorige">
        </v-hover>
      </button>
      <v-carousel-item v-for="potato in potatoes" :key="potato.title">
        <potato :item="potato"/>
      </v-carousel-item>
      <button v-show="carousel !== potatoes.length - 1" class="next" @click="carousel++">
        <v-hover
          v-slot:default="{ hover }"
        >
          <img :src="hover ? require('~/assets/img/icon-btn-hover.svg') : require('~/assets/img/icon-btn.svg')" alt="Volgende">
        </v-hover>
      </button>
    </v-carousel>

    <v-container class="pa-0 pa-sm-3">
      <v-row class="pt-17" align="center" :no-gutters="$breakpoint.is.xsOnly">
        <v-col cols="12" sm="5" offset-sm="1">
          <div v-html="page.tekst_2"/>
        </v-col>
        <v-col v-if="$breakpoint.is.smAndUp" cols="12" sm="4" lg="4" offset-sm="1">
          <h4>Bekijk snel:</h4>
          <v-chip v-for="prepMethod in prepMethods" :key="prepMethod.title" color="primary" class="mt-4 mr-5" small @click="$vuetify.goTo(`#${prepMethod.permalink}`, {offset: 100})">
            {{ prepMethod.title }}
          </v-chip>
        </v-col>
        <v-col v-else cols="12" class="pa-3">
          <h4 class="mb-3">Bekijk snel:</h4>
          <v-btn
            v-for="prepMethod in prepMethods"
            :key="prepMethod.title"
            width="150px"
            class="mr-6 mb-5"
            rounded
            large
            @click="$vuetify.goTo(`#${prepMethod.permalink}`, {offset: 100})"
          >
            {{ prepMethod.title }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <section v-for="(item, index) in prepMethods" :key="item.id">
      <prep-method :item="item" :index="index"/>
    </section>
  </v-container>
</template>

<script>
import page from '~/plugins/mixins/page';
import IntroText from '~/components/IntroText';
import Potato from '~/components/Potato';
import PrepMethod from '~/components/PrepMethod';

export default {
  components: {
    IntroText,
    Potato,
    PrepMethod,
  },
  mixins: [page],
  async asyncData({$axios, error}) {
    try {
      const [prepMethods, potatoes] = await Promise.all([
        $axios.get('/methods'),
        $axios.get('/potatoes'),
      ]);
      return {
        prepMethods: prepMethods.data.data,
        potatoes: potatoes.data.data,
      };
    } catch (e) {
      error({statusCode: 503, message: e.message});
    }
  },
  data() {
    return {
      carousel: 0,
      prepMethods: [],
      potatoes: [],
    };
  },
};
</script>

<style lang="sass" scoped>
.carousel
  position: relative

  button
    position: absolute
    bottom: 8px
    outline: none

    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      bottom: 50%

  .prev
    left: 2%
    transform: scale(-1, 1)
    z-index: 2
    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      left: 10%

  .next
    right: 2%
    @media screen and (min-width: map-get($grid-breakpoints, 'sm'))
      right: 10%
</style>
